import { render, staticRenderFns } from "./report-card-small.vue?vue&type=template&id=05eab39e&scoped=true"
import script from "./report-card-small.vue?vue&type=script&lang=js"
export * from "./report-card-small.vue?vue&type=script&lang=js"
import style0 from "./report-card-small.vue?vue&type=style&index=0&id=05eab39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eab39e",
  null
  
)

export default component.exports